import { defineSong } from '../types';

export default defineSong({
  id: 'bir-derdim-var',
  title: 'Bir Derdim Var',
  level: 3,
  key: 'Bm',
  bpm: 119,
  beats: 4,
  pattern: 'DUDUDUDU',
  style: 'Alternatif rock',
  desc: 'Bas ile davul her yarım ölçüde aynı 3-3-2 ritim kalıbını vuruyor. İlk kıtada iv akorunda tek bir iç ses yarım ses inip çıkıyor; nakarat III ile aydınlanıyor ve majör V seni toniğe geri çekiyor.',
  sections: [
    {
      name: 'Giriş',
      bars: ['Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm', 'Bm'],
    },
    { name: 'Kıta', bars: ['Bm', 'Bm', 'Bm', 'Bm', 'A', 'A', 'A', 'A', 'Em7', 'Em6', 'Em7', 'Em6'] },
    { name: 'Köprü', bars: ['Bm', 'Bm', 'Bm', 'Bm', 'A', 'A', 'A', 'A', 'Em', 'Em', 'G', 'A'] },
    { name: 'Ara', bars: ['Bm', 'Bm', 'G', 'G', 'Bm', 'Bm', 'G', 'G'] },
    {
      name: 'Kıta',
      bars: ['Bm', 'Bm', 'Bm', 'Bm', 'A', 'A', 'A', 'A', 'Em', 'Em', 'Em', 'Em', 'Bm', 'Bm', 'Bm', 'Bm'],
    },
    { name: 'Nakarat', bars: ['D', 'D', 'F#', 'F#', 'Bm', 'Bm', 'G', 'G', 'Em', 'Em', 'G', 'G', 'Em', 'Em', 'G', 'A'] },
    { name: 'Ara', bars: ['Bm', 'Bm', 'G', 'G', 'Bm', 'Bm', 'G', 'G'] },
    { name: 'Son', bars: ['Em', 'Em', 'G', 'A', 'Bm', 'Bm'] },
  ],
  cover: {
    artist: 'Mor ve Ötesi',
    references: [
      'https://www.songsterr.com/a/wsa/mor-ve-otesi-bir-derdim-var-tab-s388668',
      'https://dogruakor.com/repertuar/Mor+Ve+%C3%96tesi/Bir+Derdim+Var',
      'https://www.guitartabsexplorer.com/mor-ve-otesi/bir-derdim-var-chords',
      'https://www.akor.club/bir-derdim-var-akor-mor-ve-otesi/',
      'https://www.hurriyet.com.tr/aile/mor-ve-otesi-bir-derdim-var-akor-ve-gitar-ritimleri-41506342',
    ],
    year: 2004,
    listen: 'https://www.youtube.com/watch?v=7RW8n4iXZbA',
  },
});
